import React from 'react';
import { SearchIcon, FileQuestionIcon, RotateCcwIcon, BatteryWarningIcon } from 'lucide-react';
export function ProblemSection() {
  const scrollToOffer = () => {
    document.getElementById('offerta')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const problems = [{
    icon: <SearchIcon className="w-8 h-8 text-blue-600" data-id="element-216" />,
    title: 'Passi ore a cercare idee',
    description: 'Passi ore davanti al computer a cercare idee per le lezioni, perdendo tempo prezioso che potresti dedicare a te stesso.'
  }, {
    icon: <FileQuestionIcon className="w-8 h-8 text-blue-600" data-id="element-217" />,
    title: 'Contenuti sparsi e disorganizzati',
    description: 'Cerchi giochi motori, attività, esercizi e materiali… ma spesso trovi solo contenuti sparsi e poco organizzati.'
  }, {
    icon: <RotateCcwIcon className="w-8 h-8 text-blue-600" data-id="element-218" />,
    title: 'Ricominciare sempre da zero',
    description: 'Ogni settimana devi ricominciare da zero. Preparare le lezioni richiede molto tempo, energia e organizzazione.'
  }, {
    icon: <BatteryWarningIcon className="w-8 h-8 text-blue-600" data-id="element-219" />,
    title: 'Stanchezza e frustrazione',
    description: 'E anche quando ami il tuo lavoro, alla fine della giornata ti senti stanco e con la sensazione di non riuscire mai a stare al passo con tutto.'
  }];
  return <section className="py-20 px-4 bg-gray-50" data-id="element-220">
      <div className="max-w-5xl mx-auto" data-id="element-221">
        <div className="text-center mb-16" data-id="element-222">
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-6 leading-tight" data-id="element-223">
            Se insegni educazione fisica probabilmente{' '}
            <span className="text-blue-600" data-id="element-224">
              conosci bene questa situazione.
            </span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-225">
            Molti insegnanti vivono esattamente questa situazione. Non perché
            manchi la passione o la voglia di insegnare. Il vero problema è che
            non esiste un sistema semplice che raccolga tutte le attività in
            modo chiaro e pronto all'uso.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12" data-id="element-226">
          {problems.map((problem, index) => <div key={index} className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow" data-id="element-227">
              <div className="bg-blue-50 w-16 h-16 rounded-full flex items-center justify-center mb-6" data-id="element-228">
                {problem.icon}
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-229">
                {problem.title}
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-230">
                {problem.description}
              </p>
            </div>)}
        </div>

        <div className="text-center" data-id="element-231">
          <button onClick={scrollToOffer} className="inline-block bg-blue-600 hover:bg-blue-700 text-white font-bold text-lg py-4 px-10 rounded-full shadow-lg transform hover:-translate-y-1 transition-all duration-300" data-id="element-232">
            SCOPRI LA SOLUZIONE
          </button>
        </div>
      </div>
    </section>;
}